import { z } from 'zod';

// Disallowed disposable email domains
const DISALLOWED_DOMAINS = [
  'tempmail.com',
  'mailinator.com',
  'yopmail.com',
  'guerrillamail.com',
  '10minutemail.com',
  'trashmail.com',
  'dispostable.com',
  'getnada.com',
  'sharklasers.com',
  'fakeinbox.com',
  'throwawaymail.com',
];

export const loginSchema = z.object({
  email: z
    .string()
    .min(1, 'O e-mail corporativo é obrigatório.')
    .email('Informe um endereço de e-mail corporativo válido.')
    .trim()
    .toLowerCase(),
  password: z
    .string()
    .min(1, 'A senha é obrigatória.'),
  organizationId: z.string().optional(),
});

export type LoginFormData = z.infer<typeof loginSchema>;

export const registerSchema = z
  .object({
    fullName: z
      .string()
      .min(3, 'O nome deve ter no mínimo 3 caracteres.')
      .max(80, 'O nome deve ter no máximo 80 caracteres.')
      .refine(
        (val) => val.trim().split(/\s+/).length >= 2,
        'Informe seu nome e sobrenome completos.'
      )
      .refine(
        (val) => /^[a-zA-ZÀ-ÿ\s'-]+$/.test(val),
        'O nome contém caracteres inválidos.'
      ),
    organizationName: z
      .string()
      .min(3, 'O nome da organização deve ter no mínimo 3 caracteres.')
      .max(60, 'O nome da organização deve ter no máximo 60 caracteres.')
      .refine(
        (val) => !/^[0-[#]*$/.test(val),
        'Informe um nome de organização válido.'
      ),
    email: z
      .string()
      .min(1, 'O e-mail corporativo é obrigatório.')
      .email('Informe um e-mail em formato válido (ex: nome@empresa.com).')
      .trim()
      .toLowerCase()
      .refine((val) => {
        const domain = val.split('@')[1];
        return domain && !DISALLOWED_DOMAINS.includes(domain.toLowerCase());
      }, 'Domínios de e-mail temporários não são permitidos para contas corporativas Cyzor.'),
    password: z
      .string()
      .min(8, 'A senha corporativa deve possuir no mínimo 8 caracteres.')
      .regex(/[A-Z]/, 'A senha precisa conter pelo menos 1 letra maiúscula.')
      .regex(/[a-z]/, 'A senha precisa conter pelo menos 1 letra minúscula.')
      .regex(/[0-9]/, 'A senha precisa conter pelo menos 1 número.')
      .regex(
        /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
        'A senha precisa conter pelo menos 1 caractere especial (!@#$%...).'
      ),
    confirmPassword: z
      .string()
      .min(1, 'A confirmação de senha é obrigatória.'),
    acceptTerms: z
      .boolean()
      .refine((val) => val === true, 'Você precisa aceitar os Termos de Uso e Política de Privacidade.'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'As senhas informadas não coincidem.',
    path: ['confirmPassword'],
  });


export type RegisterFormData = z.infer<typeof registerSchema>;

